<template>
  <div class="col-12 px-0">
    <div class="trustpilot-mini-widget d-flex justify-content-center align-items-center p-0">
      <div
        :id="'trustbox-single-page-signup-'+id"
        class="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="5419b732fbfb950b10de65e5"
        data-businessunit-id="52951c010000640005776e2a"
        data-style-height="30px"
        data-style-width="100%"
        data-theme="dark"
      >
        <a
          class="t-white mx-auto"
          href="https://uk.trustpilot.com/review/www.pactcoffee.com"
          target="_blank"
          rel="noopener"
        >Trustpilot</a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, toRefs } from 'vue'

const props = defineProps({
  id: {
    type: String,
    required: true,
  }
})

const { id } = toRefs(props)

function load_trustbox() {
  const trustbox = document.getElementById('trustbox-single-page-signup-'+id.value)
  if (window.Trustpilot) {
    window.Trustpilot.loadFromElement(trustbox)
  }
}

onMounted(() => {
  load_trustbox()
})
</script>

<script>
export default {
  name: 'HeroBanner',
}
</script>

<style lang="scss" scoped>

.single-page-signup-hero-banner {
  padding: 20px 0px 0px;
  .trustpilot-mini-widget {
    @media (min-width: 768px) {
      max-width: 300px;
      margin: auto;
    }
  }
}
</style>
